import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

export default function SalesDetail() {
  const { id } = useParams();
  const [sale, setSale] = useState(null);

  useEffect(() => {
    api.get(`/sales/${id}`).then(res => setSale(res.data));
  }, [id]);

  if (!sale) return null;

  return (
    <div>
      <h3>Detalle de Venta</h3>
      <p>Cliente: {sale.client.nombre}</p>
      <p>Total: ${sale.monto_final}</p>

      <pre>{JSON.stringify(sale.invoice, null, 2)}</pre>
    </div>
  );
}
